import PropTypes from "prop-types"
import styled from "styled-components"
import { whiteTheme } from "../../../theme"

const FeatureCardImageWrapper = styled.div`
  display: flex;
  background-color: ${whiteTheme};
  padding: 10px;
  border-radius: 100%;
  box-shadow: 0 0 34px rgba(0,0,0,.25);
  position: absolute;
  top: -65px;
  height: 125px;
  width: 125px;

    ${({ theme }) => theme.se`
    flex-direction: column;
    align-items: center;
    order: 1;
    text-align: center;
  `}

    ${({ theme }) => theme.tablet`
  `}

    ${({ theme }) => theme.desktop`
    margin: auto;
  `}
`

FeatureCardImageWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default FeatureCardImageWrapper
